import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import imgTeste from '../../img/imgTeste.png' // REMOVIDO: não usado
import './styleMobile.css'
// import { FaPlus } from "react-icons/fa6"; // REMOVIDO: não usado
// import { FaMinus } from "react-icons/fa"; // REMOVIDO: não usado
// import ModalConfirmInfoCliente from "../../components/ModalConfirmInfoCliente"; // REMOVIDO: não usado
// import InputMask from "react-input-mask"; // REMOVIDO: não usado
import { FaLocationCrosshairs } from "react-icons/fa6";
// import AsyncSelect from 'react-select/async'; // REMOVIDO: não usado
// import { Controller } from 'react-hook-form'; // REMOVIDO: não usado
// import { useForm } from 'react-hook-form'; // REMOVIDO: não usado
// import Select from 'react-select'; // REMOVIDO: não usado
import { GrLocation } from "react-icons/gr";
import { RiCloseCircleLine } from "react-icons/ri";
import { updateEnderecoClientePublic, registerClientePublic, getStoreInfo, geocodePublic } from "../../services/api";
import {
    setDefaults,
    // setKey, // REMOVIDO: não usado
    // setLanguage, // REMOVIDO: não usado
    // setRegion, // REMOVIDO: não usado
    // fromAddress, // REMOVIDO: não usado
    // fromLatLng, // REMOVIDO: não usado
    // fromPlaceId, // REMOVIDO: não usado
    // setLocationType, // REMOVIDO: não usado
    // geocode, // REMOVIDO: não usado
    // RequestType, // REMOVIDO: não usado
} from "react-geocode";
import {
    useJsApiLoader,
    Autocomplete,
} from "@react-google-maps/api";
import { toast } from "react-toastify";
import regionConfig from '../../config/regionConfig';
const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';
const REACT_APP_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

// ✅ Definido FORA do componente para evitar re-criação a cada render
const libraries = ["places"];

setDefaults({
    key: process.env.REACT_APP_GOOGLE_API_KEY,
    language: regionConfig.map.language,
    region: regionConfig.map.googleRegion.toLowerCase(),
});

const AddEndereco = () => {
    const { t } = useTranslation('cardapio');

    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');

    const location = useLocation();
    const { nomeEmpresaForUrl, idEmpresa, slug } = useParams();
    const identifier = slug || idEmpresa;
    const isSlugRoute = !!slug;

    // 🔧 FIX: Obter id_empresa com fallback para sessionStorage (rotas slug)
    const getIdEmpresa = () => {
        if (idEmpresa) return idEmpresa;
        try {
            const data = sessionStorage.getItem('sessionCompany');
            if (data) return JSON.parse(data)?.id_empresa;
        } catch (e) {
            console.error('[ENDERECO] Erro ao obter id_empresa:', e);
        }
        return null;
    };
    const effectiveIdEmpresa = getIdEmpresa();

    // 🔧 FIX: buildUrl com fallback para sessionStorage
    const buildUrl = (subpath) => {
        if (isSlugRoute && slug) {
            return `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            return `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
        }
        // Fallback: buscar do sessionStorage
        try {
            const empresaData = sessionStorage.getItem('sessionCompany');
            if (empresaData) {
                const parsed = JSON.parse(empresaData);
                if (parsed?.slug) {
                    return `/c/${parsed.slug}/${subpath}`;
                } else if (parsed?.name && parsed?.id_empresa) {
                    const nomeForUrl = parsed.name.toLowerCase().replace(/\s+/g, '-');
                    return `/cardapio/${nomeForUrl}/${parsed.id_empresa}/${subpath}`;
                }
            }
        } catch (e) {
            console.error('[ENDERECO] Erro ao construir URL:', e);
        }
        console.warn('[ENDERECO] buildUrl: Não foi possível construir URL válida para:', subpath);
        return `/`;
    };
    const { personInfoObj, enderecoToEdit } = location.state || {};
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(personInfoObj);

    // const { register, control, handleSubmit, errors } = useForm(); // REMOVIDO: não usado

    const empresaEncrypted = sessionStorage.getItem('sessionCompany');
    let empresaDecrypted = null;
    try { empresaDecrypted = empresaEncrypted ? JSON.parse(empresaEncrypted) : null; } catch { empresaDecrypted = null; }
    const empresa = empresaDecrypted;
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("STRINGY BAIRROS ENTREGA:", JSON.stringify(bairros_entrega) )
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("empresa:",empresa);

    //const stateFromItemModal = location.state;
    //var fromItemAddModal = false;
    //if(stateFromItemModal !== null){
    //    fromItemAddModal = location.state.fromItemAddModal;
    //}

    const navigate = useNavigate();

    // 🔧 FIX: buildUrl com fallback para sessionStorage
    const buildUrlSafe = (subpath) => {
        if (isSlugRoute && slug) {
            return `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            return `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
        } else if (empresa?.slug) {
            return `/c/${empresa.slug}/${subpath}`;
        } else if (empresa?.name && empresa?.id_empresa) {
            const nomeForUrl = empresa.name.toLowerCase().replace(/\s+/g, '-');
            return `/cardapio/${nomeForUrl}/${empresa.id_empresa}/${subpath}`;
        }
        return null;
    };

    const handleBack = () => {
        const url = buildUrlSafe('finalizar-pedido');
        if (url) {
            navigate(
                externalId ? `${url}?external_id=${externalId}` : url,
                { state: { personInfoObj } }
            );
        } else {
            console.warn('[ENDERECO] Usando history.back() como fallback');
            navigate(-1);
        }
    }

    // const [itensCarrinho, setItensCarrinho] = useState([]); // REMOVIDO: não usado
    // const [carrinho, setCarrinho] = useState([]); // REMOVIDO: não usado
    // const [showConfirmInfo, setShowConfirmInfo] = useState(false); // REMOVIDO: não usado
    // const [infoPersonalData, setInfoPersonalData] = useState(false); // REMOVIDO: não usado
    // const [whatsappData, setWhatsappData] = useState(""); // REMOVIDO: não usado
    // const [namePersonData, setNamePersonData] = useState(""); // REMOVIDO: não usado

    const [rua, setRua] = useState("");
    const [numero, setNumero] = useState("");
    const [bairro, setBairro] = useState("");
    const [bairroEditavel, setBairroEditavel] = useState(false);
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [cep, setCep] = useState("");
    const [complemento, setComplemento] = useState("");
    const [referencia, setReferencia] = useState("");
    const [latitudeToSave, setLatitudeToSave] = useState("");
    const [longitudeToSave, setLongitudeToSave] = useState("");
    // const [addressComplete, setAddressComplete] = useState(false); // REMOVIDO: não usado

    // 🔧 FIX: Preencher campos quando estiver editando um endereço existente
    useEffect(() => {
        if (enderecoToEdit) {
            setRua(enderecoToEdit.rua || "");
            setNumero(enderecoToEdit.numero || "");
            setBairro(enderecoToEdit.bairro || "");
            setCidade(enderecoToEdit.cidade || "");
            setEstado(enderecoToEdit.estado || "");
            setCep(enderecoToEdit.cep || "");
            setComplemento(enderecoToEdit.complemento || "");
            setReferencia(enderecoToEdit.referencia || "");
            setLatitudeToSave(enderecoToEdit.latitude || "");
            setLongitudeToSave(enderecoToEdit.longitude || "");
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('[ENDERECO] Campos preenchidos com endereço para edição:', enderecoToEdit);
        }
    }, []);
    
    // ✅ Estados para controlar atualização dos dados da empresa
    const [empresaAtualizada, setEmpresaAtualizada] = useState(null);
    const [isUpdatingEmpresa, setIsUpdatingEmpresa] = useState(false);
    
    // ✅ Usar dados atualizados quando disponível, senão usar original
    const empresaFinal = empresaAtualizada || empresa;
    const regionType = empresaFinal?.region_type_delivery;
    const bairros_entrega = empresaFinal?.bairros_entrega;


    //const [estado, setEstado] = useState("");
    // Initialize the `options` state variable
    // const [options, setOptions] = useState([ // REMOVIDO: não usado
    //     { value: "", label: "Ex: Avenida Exemplo, Setor Marista" }
    // ]);
    // const [address, setAddress] = useState("") // REMOVIDO: não usado
    // const [selectedOptions, setSelectedOptions] = useState([]); // REMOVIDO: não usado
    // const [searchBox, setSearchBox] = useState(null); // REMOVIDO: não usado

    const reverseGeocode = ({ latitude: lat, longitude: lng }) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(lat, lng);
        setLatitudeToSave(lat);
        setLongitudeToSave(lng);

        // ✅ Proxy backend (a frontend key é restrita por referrer e Google
        // bloqueia esse tipo de chave em chamadas REST de Geocoding).
        geocodePublic({ latlng: `${lat},${lng}` })
            .then(response => {
                const data = response.data || {};
                const results = data.results || [];

                // Variáveis temporárias para armazenar valores
                //let numeroTemp = '';
                let ruaTemp = '';
                let bairroTemp = '';
                let cidadeTemp = '';
                let estadoTemp = '';
                let cepTemp = '';
                let cepFound = false;
                let ruaFound = false;
                let bairroFound = false;

                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("RESULTS:", results);

                // Função para processar componentes de endereço
                const processAddressComponent = (component, addressData) => {
                    const { long_name, short_name, types } = component;
                    
                    if (types.includes("route") && !addressData.cepFound && !addressData.ruaFound && !addressData.ruaTemp) {
                        addressData.ruaTemp = long_name;
                        addressData.ruaFound = true; // Marca que uma Rua foi encontrada
                    }
                    if ((types.includes("sublocality") || types.includes("neighborhood")) && !addressData.bairroFound && !addressData.bairroTemp) {
                        addressData.bairroTemp = long_name;
                        addressData.bairroFound = true;
                    }
                    if (types.includes("administrative_area_level_1") && !addressData.cepFound && addressData.ruaFound && !addressData.estadoTemp) {
                        addressData.estadoTemp = short_name;
                    }
                    if ((types.includes("administrative_area_level_2") || types.includes("locality")) && !addressData.cepFound && addressData.ruaFound && !addressData.cidadeTemp) {
                        addressData.cidadeTemp = long_name;
                    }
                    if (types.includes("postal_code") && !addressData.cepFound && addressData.ruaFound && !addressData.cepTemp) {
                        addressData.cepTemp = long_name;
                        addressData.cepFound = true; // Marca que um CEP foi encontrado
                    }
                };

                for (const result of results) {
                    const addressComponents = result.address_components;

                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("addressComponents>", addressComponents);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("LATITUDE E LONGITUDE:", lat, ",", lng);

                    // Objeto para armazenar os dados do endereço
                    const addressData = {
                        ruaTemp,
                        bairroTemp,
                        cidadeTemp,
                        estadoTemp,
                        cepTemp,
                        cepFound,
                        ruaFound,
                        bairroFound
                    };

                    // Coleta dados de addressComponents sem modificar o estado diretamente
                    for (const component of addressComponents) {
                        processAddressComponent(component, addressData);
                    }

                    // Atualiza as variáveis com os valores processados
                    ruaTemp = addressData.ruaTemp;
                    bairroTemp = addressData.bairroTemp;
                    cidadeTemp = addressData.cidadeTemp;
                    estadoTemp = addressData.estadoTemp;
                    cepTemp = addressData.cepTemp;
                    cepFound = addressData.cepFound;
                    ruaFound = addressData.ruaFound;
                    bairroFound = addressData.bairroFound;

                    // Se um CEP foi encontrado, não precisa buscar nos próximos resultados
                    if (cepFound && ruaFound && bairroFound) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Detalhes do endereço definidos.");
                        //setAddressComplete(true); // Atualiza o estado para indicar que o endereço está completo
                        break; // Sai do loop uma vez que um CEP foi encontrado e as informações foram definidas
                    }
                }

                // Agora atualiza os estados, mas só para os campos que estão vazios
                setRua((prevRua) => prevRua || ruaTemp);
                //setNumero((prevNumero) => prevNumero || numeroTemp);
                setBairro((prevBairro) => prevBairro || bairroTemp);
                setCidade((prevCidade) => prevCidade || cidadeTemp);
                setEstado((prevEstado) => prevEstado || estadoTemp);
                setCep((prevCep) => prevCep || cepTemp);

                if (!cepFound && !ruaFound) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Nenhum CEP ou Rua encontrado para as coordenadas fornecidas.');
                    toast(t('address.notFound'), { autoClose: 5000, type: 'warning' });
                }
            })
            .catch(error => {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao realizar geocodificação reversa:', error);
                toast(t('address.geocodeError'), { autoClose: 5000, type: 'error' });
            });
    };


    const findMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("position.coords:", position.coords);
                    reverseGeocode(position.coords);
                },
                error => {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Error Code = " + error.code + " - " + error.message);
                    toast(t('address.geolocationError', { error: error.message }), { autoClose: 5000, type: 'error' });
                },
                {
                    enableHighAccuracy: true,  // Alta precisão, pode consumir mais bateria
                    timeout: 10000,            // Aumenta o tempo máximo para obter a localização
                    maximumAge: 0              // Não usa posições em cache, força a localização atual
                }
            );
        } else {
            toast(t('address.geolocationUnavailable'), { autoClose: 5000, type: 'warning' });
        }
    };

    /*const onLoad = (ref) => {
        setSearchBox(ref);
    }

    const onPlacesChanged = () => {
        //const searchBox = searchBox;
        if (searchBox) {
          const places = searchBox.getPlaces();
          if (places.length > 0) {
            const place = places[0];
            const location = {
              lat: place.geometry?.location.lat() || 0,
              lng: place.geometry?.location.lng() || 0,
            };
            reverseGeocode({ latitude: location.lat, longitude: location.lng})
          }
        }
    }*/
    const [autocomplete, setAutocomplete] = useState(null);
    //const [address, setAddress] = useState('');

    // ✅ useJsApiLoader: idempotente, não carrega Google Maps API 2x
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: REACT_APP_GOOGLE_API_KEY,
        libraries: libraries,
        language: regionConfig.map.language,
        region: regionConfig.map.googleRegion,
    });

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    /*const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();
            const location = {
                lat: place.geometry?.location.lat() || 0,
                lng: place.geometry?.location.lng() || 0,
            };
            reverseGeocode({ latitude: location.lat, longitude: location.lng });
            setAddress(place.formatted_address);
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('location:', location);
        } else {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Autocomplete is not loaded yet!');
        }
    };*/
    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();

            // Pega a localização (lat, lng)
            const location = {
                lat: place.geometry?.location.lat() || 0,
                lng: place.geometry?.location.lng() || 0,
            };

            // Extrai os componentes do endereço diretamente do place
            const addressComponents = place.address_components;

            // Resetando estados para evitar informações desatualizadas
            setRua("");
            setNumero("");
            setBairro("");
            setCidade("");
            setEstado("");
            setCep("");

            // Itera sobre os componentes de endereço do autocomplete
            addressComponents.forEach(component => {
                const { long_name, short_name, types } = component;

                if (types.includes("street_number")) {
                    setNumero(long_name);
                }
                if (types.includes("route")) {
                    setRua(long_name);
                }
                if (types.includes("sublocality") || types.includes("neighborhood")) {
                    setBairro(long_name);
                }
                if (types.includes("administrative_area_level_1")) {
                    setEstado(short_name);
                }
                if (types.includes("administrative_area_level_2") || types.includes("locality")) {
                    setCidade(long_name);
                }
                if (types.includes("postal_code")) {
                    setCep(long_name);
                }
            });

            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("console>", place.formatted_address);

            // Chama a geocodificação reversa apenas se precisar de algum dado adicional com base na lat/lng
            reverseGeocode({ latitude: location.lat, longitude: location.lng });
        } else {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Autocomplete is not loaded yet!');
        }
    };

    const handleClearAddress = () => {
        setRua("");
        setNumero("");
        setBairro("");
        setCidade("");
        setEstado("");
        setCep("");
    }

    // ── FALLBACK QUANDO O GOOGLE MAPS NAO CARREGA ───────────────────────────
    // Sem isto, uma queda do Maps ZERA a venda: o campo de endereco fica
    // `disabled` para sempre e o cliente nao consegue nem digitar na mao.
    // Queda de fornecedor externo tem que degradar, nao travar.
    //
    // Sao TRES sinais distintos, porque a falha se manifesta de jeitos diferentes:
    //   loadError    -> o script nem baixou (rede, bloqueio)
    //   gm_authFailure -> o script baixou mas a chave/faturamento estao invalidos.
    //                     Foi o caso do trial do Google Cloud expirando: o
    //                     bootstrap respondia 200 e SO falhava em runtime, entao
    //                     loadError nunca disparava.
    //   timeout      -> nem carregou nem deu erro; nao deixar o cliente esperando.
    const [mapsFalhou, setMapsFalhou] = useState(false);

    useEffect(() => {
        if (loadError) {
            console.warn('[ENDERECO] Google Maps nao carregou:', loadError.message);
            setMapsFalhou(true);
            return;
        }

        const anterior = window.gm_authFailure;
        window.gm_authFailure = () => {
            console.warn('[ENDERECO] Google Maps recusou a chave (auth/faturamento)');
            setMapsFalhou(true);
            if (typeof anterior === 'function') anterior();
        };

        const timer = setTimeout(() => {
            if (!isLoaded) {
                console.warn('[ENDERECO] Google Maps nao respondeu a tempo');
                setMapsFalhou(true);
            }
        }, 8000);

        return () => {
            clearTimeout(timer);
            window.gm_authFailure = anterior;
        };
    }, [loadError, isLoaded]);

    const handleSaveAddress = async () => {

        if (rua !== "" && numero !== "" && bairro !== "" && cidade !== "" && estado !== "") {
            const addressObj = {
                rua: rua,
                numero: numero,
                bairro: bairro,
                cidade: cidade,
                estado: estado,
                cep: cep,
                complemento: complemento,
                referencia: referencia,
                latitude: latitudeToSave,
                longitude: longitudeToSave
            }

            try {
                // 🔧 FIX: Garantir que o cliente existe no banco ANTES de salvar endereço
                // O endpoint /client/register faz upsert: cria se não existe, retorna se já existe
                await registerClientePublic(effectiveIdEmpresa, personInfoObj.nome, personInfoObj.telefone);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('[ENDERECO] Cliente registrado/verificado com sucesso');

                // Agora salvar o endereço (cliente já existe no banco)
                const response = await updateEnderecoClientePublic(effectiveIdEmpresa, personInfoObj.telefone, addressObj, enderecoToEdit);

                if (response.status === 200) {
                    toast(t('address.addressSaved'), { autoClose: 5000, type: 'success' });
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response)
                    personInfoObj.endereco = response.data.response.endereco;

                    // 🎯 SELEÇÃO AUTOMÁTICA: Encontrar o endereço recém-criado e marcá-lo para seleção
                    const enderecosCriados = response.data.response.endereco;
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📍 Endereços retornados após criação:", enderecosCriados);

                    if (enderecosCriados && enderecosCriados.length > 0) {
                        // O endereço recém-criado é o que tem os mesmos dados que acabamos de enviar
                        const novoEndereco = enderecosCriados.find(endereco =>
                            endereco.rua === rua &&
                            endereco.numero === numero &&
                            endereco.bairro === bairro &&
                            endereco.cidade === cidade
                        );

                        if (novoEndereco) {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Endereço recém-criado identificado:", novoEndereco);
                            // Passar informação de qual endereço deve ser selecionado automaticamente
                            personInfoObj.autoSelectEnderecoId = novoEndereco._id;
                        }
                    }

                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚀 Navegando com dados:", personInfoObj);
                    navigate(
                        externalId
                            ? `${buildUrl('finalizar-pedido')}?external_id=${externalId}`
                            : buildUrl('finalizar-pedido'),
                        { state: { personInfoObj } }
                    );
                } else {
                    toast(t('address.addressSaveError'), { autoClose: 5000, type: 'error' });
                }
            } catch (error) {
                console.error('[ENDERECO] Erro ao salvar endereço:', error);
                toast(t('address.addressSaveError'), { autoClose: 5000, type: 'error' });
            }
        } else {
            toast(t('address.fillRequiredFields'), { autoClose: 5000, type: 'warning' });
        }
    }

    /*
    useEffect(() => {
        if(addressComplete){
            if(rua===""){toast('Digite o nome da rua!', {autoClose:5000, type: 'warning'})}
            if(bairro===""){toast("Digite o nome do bairro!", {autoClose:5000, type: 'warning'})}
            if(cidade===""){toast("Digite o nome da cidade!", {autoClose:5000, type: 'warning'})}
        }
        setAddressComplete(false);
    }, [addressComplete]);*/

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
        if (regionType === "bairro") {
            toast(t('address.neighborhoodNotServed'), { autoClose: 5000, type: 'warning', position: "bottom-center" });
        }
    }, [regionType]);

    // ✅ useEffect para verificar e atualizar dados da empresa quando necessário
    useEffect(() => {
        // Se não há dados da empresa ou já está atualizando, não fazer nada
        if (!empresaFinal || isUpdatingEmpresa) return;
        
        // Verificar se os dados podem estar desatualizados
        // Atualizar se não há informação de tipo de região
        if (!regionType) {
            setIsUpdatingEmpresa(true);

            getStoreInfo(identifier)
                .then(response => {
                    const novaEmpresa = response.data.empresaData;

                    // Atualizar sessionStorage com os novos dados
                    sessionStorage.setItem("sessionCompany", JSON.stringify(novaEmpresa));

                    setEmpresaAtualizada(novaEmpresa);
                    setIsUpdatingEmpresa(false);

                    // Recarregar a página para aplicar as mudanças
                    window.location.reload();
                })
                .catch(error => {
                    setIsUpdatingEmpresa(false);
                });
        }
    }, [empresaFinal, regionType, identifier, isUpdatingEmpresa]);

    return (

        <div className="flex flex-col max-w-sm mx-auto bg-white rounded-lg shadow-md overflow-hidden md:max-w-2xl">

            <div className="carrinhoHeader">
                <div className="backButtonCarrinho" onClick={() => handleBack()}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={28}
                        height={28}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-left"
                    >
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                </div>
                <span>{t('address.newAddress')}</span>
            </div>

            <div className="carrinhoContainer">



                <div className="divAddEnderecoPadding">
                    <span style={{ fontSize: 20, fontWeight: '700' }}>{t('address.enterFullAddress')}</span>

                    
                    {
                        regionType === "bairro" ?
                            <div className="divEnderecoCompleto">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.neighborhood')}</label>
                                        <select
                                            value={bairro}
                                            onChange={(e) => setBairro(e.target.value)}
                                            className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                        >
                                            <option value="">{t('address.selectNeighborhood')}</option>
                                            {bairros_entrega.map((bairro, index) => (
                                                <option key={bairro._id} value={bairro.bairro_entrega}>
                                                    {bairro.bairro_entrega}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.street')}</label>
                                        <input value={rua} onChange={(e) => setRua(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.streetPlaceholder')} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.state')}</label>
                                        <input value={estado} onChange={(e) => setEstado(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.statePlaceholder')} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.city')}</label>
                                        <input value={cidade} onChange={(e) => setCidade(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.cityPlaceholder')} />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.number')}</label>
                                        <input value={numero} onChange={(e) => setNumero(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.numberPlaceholder')} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.complement')}</label>
                                        <input value={complemento} onChange={(e) => setComplemento(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.complementPlaceholder')} />
                                    </div>
                                </div>
                                <div style={{ paddingTop: '10px' }}>
                                    <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.reference')}</label>
                                    <input value={referencia} onChange={(e) => setReferencia(e.target.value)} className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                        placeholder={t('address.referencePlaceholder')} />
                                </div>
                            </div>
                            :
                            rua !== "" || bairro !== "" || cidade !== "" || estado !== "" ?

                                <div className="divEnderecoCompleto">
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 10, alignItems: 'center', paddingBottom: 12, paddingTop: 12 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <GrLocation style={{ fontSize: 22, color: 'rgb(180,180,180)' }} />
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span style={{ fontSize: 16, fontWeight: '600', maxWidth: '320px' }}>{rua}</span>
                                                <span style={{ fontSize: 15, color: 'rgb(180,180,180)', maxWidth: '320px' }}>{!bairro ? "" : `${bairro}, `}{!cidade ? "" : `${cidade} - `}{!estado ? "" : estado}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <RiCloseCircleLine onClick={() => handleClearAddress()} style={{ fontSize: 22, color: 'orangered', marginRight: '10px' }} />
                                        </div>
                                    </div>
                                    {bairro === "" || bairroEditavel ? (
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.neighborhood')}</label>
                                                <input
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                    className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.neighborhoodPlaceholder')}
                                                    onFocus={() => setBairroEditavel(true)} // Manter o input visível enquanto o usuário digita
                                                    onBlur={() => bairro !== "" && setBairroEditavel(false)} // Ocultar o input se o bairro for preenchido
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.number')}</label>
                                            <input value={numero} onChange={(e) => setNumero(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                placeholder={t('address.numberPlaceholder')} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.complement')}</label>
                                            <input value={complemento} onChange={(e) => setComplemento(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                placeholder={t('address.complementPlaceholder')} />
                                        </div>
                                    </div>
                                    <div style={{ paddingTop: '10px' }}>
                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('address.reference')}</label>
                                        <input value={referencia} onChange={(e) => setReferencia(e.target.value)} className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                            placeholder={t('address.referencePlaceholder')} />
                                    </div>
                                </div>
                                :
                                <>
                                    <label style={{ fontWeight: '500', fontSize: 14 }}>{t('address.enterAddress')}</label>
                                    <div className="map">
                                        {mapsFalhou ? (
                                            /* Busca indisponivel: campos manuais. Salva sem
                                               coordenadas -- a taxa cai na regra por bairro,
                                               que ja existe. Melhor entregar sem raio do que
                                               nao vender. */
                                            <div className="endereco-manual">
                                                <p className="endereco-manual-aviso">
                                                    {t('address.manualFallbackNotice', 'A busca de endereco esta indisponivel no momento. Preencha os campos abaixo.')}
                                                </p>
                                                <input
                                                    className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.street', 'Rua')}
                                                    value={rua}
                                                    onChange={(e) => setRua(e.target.value)}
                                                />
                                                <input
                                                    className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.neighborhood', 'Bairro')}
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                />
                                                <input
                                                    className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.city', 'Cidade')}
                                                    value={cidade}
                                                    onChange={(e) => setCidade(e.target.value)}
                                                />
                                                <input
                                                    className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.state', 'Estado')}
                                                    value={estado}
                                                    onChange={(e) => setEstado(e.target.value)}
                                                />
                                            </div>
                                        ) : isLoaded ? (
                                            <Autocomplete
                                                onLoad={onLoad}
                                                onPlaceChanged={onPlaceChanged}
                                                options={{ componentRestrictions: { country: regionConfig.identity.defaultCountry } }}
                                            >
                                                <input
                                                    className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                    placeholder={t('address.searchPlaceholder')}
                                                />
                                            </Autocomplete>
                                        ) : (
                                            <input
                                                className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                placeholder={t('address.loadingMap')}
                                                disabled
                                            />
                                        )}
                                    </div>

                                    {!mapsFalhou && (
                                    <div onClick={findMyLocation} className="divBtnUseLocation">
                                        <FaLocationCrosshairs />
                                        <span>{t('address.useMyLocation')}</span>
                                    </div>
                                    )}
                                </>
                    }
                </div>

            </div>

            <div className="avancarDetalhe">
                <button onClick={() => handleSaveAddress()} className="btnAvancarDetalhe" style={{ justifyContent: 'center' }}>
                    <p style={{ marginBottom: "0px" }}>{t('address.save')}</p>
                </button>
            </div>


        </div>

    );
}

export default AddEndereco;